// extracted by mini-css-extract-plugin
export default {"header":"Header_header__A7MiM","h1":"Header_h1__HTblI","h4":"Header_h4__Ppy+A"};